<template>
  <div>
    <div @mouseup="lookUp" @mousedown="lookDown" class="center">
      <div class="img">
        <img :src="$global.imgUrl + detailsData.data.cover" alt="" />
      </div>
      <div v-if="detailsData.data.title" class="title" v-html="detailsData.data.title"></div>
      <div v-if="detailsData.data.organizerList && detailsData.data.organizerList.length > 0" class="content-box">
        <img src="@/assets/img/qietu/meetIcon.png" alt="" />
        <div class="label">主办单位</div>
        <span style="line-height: 25px">：</span>
        <div class="content">
          <span
            style="margin-right: 5px"
            class="unit"
            v-for="item in detailsData.data.organizerList"
            :key="item.id"
            @click="toDetail(item)"
            >{{ item.name }}</span
          >
        </div>
      </div>
      <div v-if="detailsData.data.beginTime || detailsData.data.endTime" class="content-box">
        <img src="@/assets/img/qietu/meetIcon1.png" alt="" />
        <div class="label">时间</div>
        <span style="line-height: 25px">：</span>
        <div class="content">
          {{ detailsData.data.beginTime }} - {{ detailsData.data.endTime }}
        </div>
      </div>
      <div v-if="detailsData.data.province || detailsData.data.city || detailsData.data.address" class="content-box">
        <img src="@/assets/img/qietu/meetIcon2.png" alt="" />
        <div class="label">地点</div>
        <span style="line-height: 25px">：</span>
        <div class="content">
          {{ detailsData.data.province }} {{ detailsData.data.city }}
          {{ detailsData.data.address }}
        </div>
      </div>
      <div
        class="content-box"
        v-if="detailsData.data.coOrganizerList && detailsData.data.coOrganizerList.length > 0"
      >
        <img src="@/assets/img/qietu/meetIcon3.png" alt="" />
        <div class="label">协办单位</div>
        <span style="line-height: 25px">：</span>
        <div class="content">
          <span
            style="margin-right: 5px"
            class="unit"
            v-for="item in detailsData.data.coOrganizerList"
            :key="item.id"
            @click="toDetail(item)"
            >{{ item.name }}</span
          >
        </div>
      </div>
      <div
        class="content-box"
        v-if="detailsData.data.undertakerList && detailsData.data.undertakerList.length > 0"
      >
        <img src="@/assets/img/qietu/meetIcon4.png" alt="" />
        <div class="label">承办单位</div>
        <span style="line-height: 25px">：</span>
        <div class="content">
          <span
            style="margin-right: 5px"
            class="unit"
            v-for="item in detailsData.data.undertakerList"
            :key="item.id"
            @click="toDetail(item)"
            >{{ item.name }}</span
          >
        </div>
      </div>
      <Registration v-if="detailsData.data.open === 1" :detailsData="detailsData.data"/>
      <div id="anchorTagThree" class="introduce">会议介绍</div>
      <p class="introduce-box" v-html="detailsData.data.content"></p>
      <div v-if="detailsData.data.committees && detailsData.data.committees.length > 0">
        <div id="anchorTagFour" class="introduce">组委会</div>
        <div class="committee">
          <div
            class="item"
            v-for="item in detailsData.data.committees"
            :key="item.id"
          >
            <div class="left">
              <img
                v-if="item.headImg"
                :src="$global.imgUrl + item.headImg"
                style="width: 64px; height: 64px; border-radius: 50%"
                alt=""
              />
              <Big v-else width="64" height="64" size="20" :big="item.userName" />
            </div>
            <div class="right">
              <div>
                <span class="author">{{ item.userName }}</span>
                <span class="Position">
                  <span v-for="i in item.titles" :key="i.id"
                    >{{ i.levelTwo }}
                  </span></span
                >
              </div>
              <div v-if="item.orgName" class="site">{{ item.orgName }}</div>
              <div class="territory" v-if="item.researchDirection">
                <span>研究方向：{{ item.researchDirection }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="(detailsData.data.edits && detailsData.data.edits.length > 0) || detailsData.data.solicitContent">
        <div id="anchorTagFive" class="introduce">征稿信息</div>
        <div
          class="FillingInformation"
          v-for="item in detailsData.data.edits"
          :key="item.id"
        >
          <div class="left">
            <div class="h">{{ item.perName }}</div>
            <div class="bottom">
              <div class="img">
                <img :src="$global.imgUrl + item.perImg" alt="" />
              </div>
              <div class="detai">
                <div>
                  <span class="h">{{ item.userName }}</span>
                  <span class="post">{{ item.post }}</span>
                </div>
                <div class="phone">{{ item.phone }}</div>
                <div class="site">{{ item.stampName }}</div>
                <div class="url">{{ item.website }}</div>
              </div>
            </div>
          </div>
          <div class="right">
            <div @click="toBusiness(item.userId, item.perId)" class="contribute">
              <img src="@/assets/img/qietu/tg.png" alt="" />
              <div>点击投稿</div>
            </div>
            <div class="attention">
              注意：1、投稿方式：a)在提供的网站上登录后即可在首页提交稿件,b)将论文电子稿发送至邮箱：conf@cqvip.com2、征稿截止日期：2021年12月26日
            </div>
          </div>
        </div>
        <div class="PressDirection">
          <p v-html="detailsData.data.solicitContent"></p>
        </div>
      </div>
      <div v-if="detailsData.data.imgVideos && detailsData.data.imgVideos.length > 0">
        <div v-if="detailsData.data.imgVideos.some((item)=>item.type === 1)">
          <div id="anchorTagSix" class="introduce">会议图片</div>
          <div class="meetingImg">
            <div v-for="item in detailsData.data.imgVideos" :key="item.id">
              <div class="list-item" v-if="item.type === 1">
                <div class="item-img">
                  <img :src="$global.imgUrl + item.url" alt="" />
                  <div class="mask">
                    <Icon
                      style="vertical-align: middle; cursor: pointer"
                      color="#fff"
                      size="26"
                      type="ios-eye-outline"
                      @click="imgPreview($global.imgUrl + item.url)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="detailsData.data.imgVideos.some((item)=>item.type === 2)">
          <div id="anchorTagSeven" class="introduce">会议视频</div>
          <div class="meetingVideo">
            <div v-for="item in detailsData.data.imgVideos" :key="item.id">
              <div v-if="item.type === 2" class="list-item">
                <div class="item-img">
                  <video :src="$global.imgUrl + item.url"></video>
                  <div class="mask">
                    <Icon
                      style="vertical-align: middle; cursor: pointer"
                      color="#fff"
                      size="26"
                      type="ios-play"
                      @click="videoPreview($global.imgUrl + item.url)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <LookUpTheWord
      @CloseToRetrieve="CloseToRetrieve"
      :coord="coord"
      v-if="isCheck"
    />
  </div>
</template>

<script>
import { imgPreview, videoPreview } from "@/utils/previewMethod.js";
import LookUpTheWord from "@/components/pager/lookUpTheWord.vue";
import Registration from "@/views/PCView/details/meetingDetails/components/Registration.vue";
export default {
  name: "center",
  props: ["detailsData"],
  components: {
    LookUpTheWord,
    Registration,
  },
  data() {
    return {
      isCheck: false,
      coord: {
        x: 0,
        y: 0,
        text: "",
      },
    };
  },
  watch: {
    //监视词条
    "coord.text": {
      //如果有内容则显示组件
      immediate: true, //立即执行
      handler() {
        if (this.coord.text && !/^\s+$/.test(this.coord.text)) {
          this.isCheck = true;
        }
      },
    },
  },
  created() {},
  methods: {
    imgPreview,
    videoPreview,
    toDetail(obj) {
      if(obj.orgId) {
        let routeUrl = this.$router.resolve({
          path: "/recommend",
          query: {
            id: obj.orgId,
          },
        });
        window.open(routeUrl.href, "_blank");
      }
    },
    // 鼠标按下
    lookDown() {
      this.isCheck = false; //关闭检索组件
    },
    // 鼠标抬起
    lookUp(event) {
      this.coord.x = event.clientX; //水平坐标
      this.coord.y = event.clientY; //垂直坐标
      this.coord.text = window.getSelection().toString(); //选中的文本
    },
    CloseToRetrieve() {
      //关闭按钮
      this.isCheck = false; //关闭组件
    },
    // 征稿信息跳采编名片
    toBusiness(userId, perId) {
      let token = sessionStorage.getItem("token");
      let dev = `https://cbtest.cnknowledge.com?${token ? 'token=' + token + '&': ''}editId=${userId}&perId=${perId}`;
      let yu = `//yucard.cnknowledge.com?${token ? 'token=' + token + '&': ''}editId=${userId}&perId=${perId}`;
      let pro = `https://card.cnknowledge.com?${token ? 'token=' + token + '&': ''}editId=${userId}&perId=${perId}`;
      let url = "";
      if (
        location.host.indexOf("test.") != -1 ||
        location.host.indexOf(":80") != -1
      ) {
        url = dev;
      } else if (location.host.indexOf("yu") != -1) {
        url = yu;
      } else {
        url = pro;
      }
      window.open(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.center {
  padding: 30px;
  width: 800px;
  background: #ffffff;
  border: 1px solid #a3cbe7;
  border-radius: 10px;
  .img {
    margin-bottom: 40px;
    width: 100%;
    height: 420px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .title {
    margin-bottom: 20px;
    font-size: 26px;
    font-family: PingFang SC;
    color: #263d78;
  }
  .content-box {
    display: flex;
    margin-bottom: 16px;
    img {
      margin-top: 2px;
      margin-right: 5px;
      width: 20px;
      height: 20px;
    }
    .label {
      display: inline-block;
      width: 62px;
      height: 25px;
      line-height: 25px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #666666;
      vertical-align: middle;
      text-align: justify;
      text-align-last: justify;
      &::after {
        content: " ";
        display: inline-block;
        width: 100%;
      }
    }
    .content {
      flex: 1;
      line-height: 25px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #000000;
      .unit {
        color: #2042bd;
        cursor: pointer;
      }
    }
  }
  .introduce {
    margin: 30px 0;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
  }
  .introduce-box {
    width: 100%;
    &::v-deep img,
    &::v-deep video {
      max-width: 100%;
    }
    &::v-deep span {
      white-space: normal !important;
    }
  }
  .committee {
    display: flex;
    flex-wrap: wrap;
    // justify-content:space-between;
    margin-bottom: 30px;
    padding: 0 30px;
    width: 100%;
    img {
      width: 55px;
      height: 55px;
    }
    .item {
      display: flex;
      width: 310px;
      margin-bottom: 90px;
      margin-right: 20px;
      .left {
        margin-right: 10px;
      }
      .right {
        color: #333333;
        .author {
          display: inline-block;
          max-width: 75px;
          font-size: 18px;
          color: #263d78;
          font-weight: bold;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .Position {
          display: inline-block;
          max-width: 125px;
          color: #1876f0;
          margin-left: 24px;
          position: relative;
          top: -2px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .site {
          width: 230px;
          margin-top: 5px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .territory {
          width: 230px;
          margin-top: 5px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .FillingInformation {
    width: 100%;
    margin-top: 30px;
    display: flex;
    .left {
      width: 350px;
      height: 200px;
      padding: 20px 25px;
      background-image: url("~@/assets/img/qietu/mp.png");
      border: 1px solid #33333321;
      border-top: none;
      border-radius: 10px;
      .h {
        font-size: 25px;
        color: #333333;
        font-weight: bold;
      }
      .bottom {
        margin-top: 20px;
        display: flex;
        .img {
          width: 70px;
          height: 95px;
          box-shadow: 5px 5px 10px rgb(200, 200, 255);
          img {
            width: 70px;
            height: 95px;
          }
        }
        .detai {
          margin-left: 10px;
          .h {
            display: inline-block;
            max-width: 80px;
            font-size: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: break-word;
          }
          .post {
            position: relative;
            top: -3px;
            display: inline-block;
            margin-left: 20px;
            max-width: 130px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: break-word;
          }
          .phone {
            width: 230px;
            font-size: 12px;
            margin: 5px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: break-word;
          }
          .site,
          .url {
            width: 230px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: break-word;
          }
        }
      }
    }
    .right {
      padding: 10px 30px;
      .contribute {
        width: 80px;
        height: 110px;
        cursor: pointer;
        img {
          width: 70px;
          height: 70px;
        }
        div {
          color: #2150cb;
          font-size: 18px;
        }
      }
      .attention {
        width: 328;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        margin-top: 20px;
        font-size: 12px;
      }
    }
  }
  .PressDirection {
    width: 100%;
    padding-left: 10px;
    margin-bottom: 30px;
    p {
      margin-top: 10px;
    }
  }
  .meetingImg,
  .meetingVideo {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin: 30px 0 0;
    .list-item {
      margin-right: 16px;
      margin-bottom: 25px;
      width: 230px;
      &:nth-child(4n) {
        margin-right: 0;
      }
      .item-img {
        position: relative;
        width: 100%;
        height: 150px;
        img {
          width: 100%;
          height: 100%;
        }
        video {
          width: 100%;
          height: 100%;
        }
        .mask {
          display: none;
          position: absolute;
          background: rgba(61, 60, 60, 0.779);
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          line-height: 150px;
          text-align: center;
          color: #fff;
        }
        &:hover .mask {
          display: block;
        }
      }
    }
  }
}
</style>